module.exports = __webpack_public_path__ + "img/service2.47a1f19b.png";